module.exports = __webpack_public_path__ + "static/media/andy_zeff.7c746835.png";